import React from 'react'
import { Button, Lazyload } from '~/components'
import * as st from '~/assets/styl/Negotiation.module.styl'
import image from '~/assets/img/reuniao-atendimento.webp'
import { useLanguage } from '~/hooks'

export default function Negotiation() {
  const { t } = useLanguage()

  return (
    <section className={st.core}>
      <Lazyload
        src={image}
        className={st.image}
        role="img"
        aria-label={t('Negotiation.imageAlt')}
      />
      <div className={st.content}>
        <h2>{t('Negotiation.title')}</h2>
        <p>{t('Negotiation.paragraph')}</p>
        <Button outlined className={st.cta} href="/#FaleConosco">
          {t('Negotiation.button')}
        </Button>
      </div>
    </section>
  )
}
